module.exports = __webpack_public_path__ + "img/advantages-bg.3a0b23c.webp";